import { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

class ScrollToTop extends Component {
  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      window.scrollTo(0, 0);
      this.props.onUpdate();
    }
  }

  render() {
    return this.props.children;
  }
}

ScrollToTop.propTypes = {
  location: PropTypes.objectOf(PropTypes.shape).isRequired,
  children: PropTypes.objectOf(PropTypes.shape).isRequired,
  onUpdate: PropTypes.func.isRequired,
};

export default withRouter(ScrollToTop);



// WEBPACK FOOTER //
// ./src/components/App/ScrollToTop.jsx